import React from "react";
import { useRole } from "@/hooks/useRole";
import { Routes, Route, Navigate } from "react-router-dom";
import { Loader2, TestTube } from "lucide-react";
import { AccessDenied } from "../components/admin/games/AccessDenied";
import { AdminDashboardHeader } from "../components/admin/dashboard/AdminDashboardHeader";
import { AdminDashboardContent } from "../components/admin/dashboard/AdminDashboardContent";
import { EmailTestComponent } from "@/components/debug/EmailTestComponent";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

// Import admin pages
import JogosAdmin from "./admin/JogosAdmin";
import MentoriasAdmin from "./admin/MentoriasAdmin";
import UsuariosAdmin from "./admin/UsuariosAdmin";
import SaquesAdmin from "./admin/SaquesAdmin";
import FinancasAdmin from "./admin/FinancasAdmin";
import DepoimentosAdmin from "./admin/DepoimentosAdmin";
import { BannersAdmin } from "./admin/BannersAdmin";
import HeroBackgroundSettings from "@/components/admin/HeroBackgroundSettings";
import DestaquesAdmin from "./admin/DestaquesAdmin";

const AdminPanel = () => {
  const { role, loading } = useRole();

  if (loading) return (
    <div className="flex items-center justify-center min-h-screen bg-[#0f141c] pt-16">
      <Loader2 className="h-12 w-12 text-[#00B6F0] animate-spin" />
    </div>
  );
  
  // Só redireciona se não está carregando E o role não é admin
  // Isso evita redirecionamento durante o carregamento inicial
  if (!loading && role !== "admin")
    return <AccessDenied />;

  return (
    <div className="bg-[#0f141c] min-h-screen pt-16 p-8">
      <div className="max-w-6xl mx-auto space-y-6">
        <Routes>
          {/* Dashboard principal */}
          <Route path="/" element={
            <>
              <AdminDashboardHeader />
              <AdminDashboardContent />
              
              {/* Ferramentas de Debug */}
              <div className="mt-8 space-y-6">
                {/* Componente de Debug Email */}
                <EmailTestComponent />
                
                {/* Link para teste completo de templates */}
                <Card className="bg-[#1a1f2e] border-gray-800">
                  <CardHeader>
                    <CardTitle className="text-white flex items-center gap-2">
                      <TestTube className="h-5 w-5 text-blue-400" />
                      Teste Avançado de Templates
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-400 mb-4">
                      Teste todos os 12 templates de email da plataforma com dados de exemplo completos.
                    </p>
                    <Button 
                      onClick={() => window.open('/debug/templates', '_blank')}
                      className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600"
                    >
                      <TestTube className="mr-2 h-4 w-4" />
                      Abrir Página de Teste Completo
                    </Button>
                  </CardContent>
                </Card>
              </div>
            </>
          } />
          
          {/* Rotas das páginas admin */}
          <Route path="/jogos" element={<JogosAdmin />} />
          <Route path="/usuarios" element={<UsuariosAdmin />} />
          <Route path="/mentorias" element={<MentoriasAdmin />} />
          <Route path="/depoimentos" element={<DepoimentosAdmin />} />
          <Route path="/banners" element={<BannersAdmin />} />
          <Route path="/saques" element={<SaquesAdmin />} />
          <Route path="/financas" element={<FinancasAdmin />} />
          <Route path="/hero" element={<HeroBackgroundSettings />} />
          <Route path="/destaques" element={<DestaquesAdmin />} />
          
          {/* Redirect para dashboard se rota não encontrada */}
          <Route path="*" element={<Navigate to="/painel-admin" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminPanel;
